module.exports = "<p *ngIf=\"loggedIn\">\r\n  Select one of the menu\r\n</p>\r\n"